export default "__VITE_ASSET__C_ENvI9N__"